// StudentSelector.js
import React from "react";
import {
  Autocomplete,
  TextField,
  Button,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import Box from "@mui/material/Box";

export const StudentSelector = ({
  studentsData,
  studentAutocompleteValue,
  handleStudentChange,
  studentsLoading,
  mobile,
}) => {
  const defaultProps = {
    options: studentsData,
    getOptionLabel: (option) => option.fullname || "",
  };

  return (
    <Box
      sx={{
        bgcolor: "#1A1A1A",
        boxShadow: 4,
        padding: 1,
        marginTop: 10,
        marginBottom: 3,
        minWidth: mobile ? "100%" : "60vw",
      }}
    >
      {studentsLoading ? (
        <CircularProgress />
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Autocomplete
            {...defaultProps}
            id="combo-box-demo"
            renderOption={(props, option) => (
              <div>
                <Tooltip placement="left" title={option.cr855_codersportsemail}>
                  <Button
                    sx={{ textTransform: "none" }}
                    component="li"
                    {...props}
                    fullWidth
                  >
                    {props.key}
                  </Button>
                </Tooltip>
              </div>
            )}
            value={studentAutocompleteValue}
            style={{ width: "90%" }}
            onChange={(e, v) => handleStudentChange(v)}
            renderInput={(params) => (
              <TextField margin="dense" {...params} label="Student" />
            )}
            disablePortal
          />
        </div>
      )}
    </Box>
  );
};
